import * as saleTotalConstant from './constants'

export const saleTotalReportNvkdRequest = (formData) => {
  return {
    type: saleTotalConstant.SALE_TOTAL_REPORT_NVKD_REQUESTING,
    formData
  }
}

export const saleTotalReportNvkdSuccess = (data) => {
  return {
    type: saleTotalConstant.SALE_TOTAL_REPORT_NVKD_SUCCESS,
    data
  }
}

export const saleTotalReportNvkdError = (error) => {
  return {
    type: saleTotalConstant.SALE_TOTAL_REPORT_NVKD_ERROR,
    error
  }
}
export const saleTotalReportKhRequest = (formData) => {
  return {
    type: saleTotalConstant.SALE_TOTAL_REPORT_KH_REQUESTING,
    formData
  }
}

export const saleTotalReportKhSuccess = (data) => {
  return {
    type: saleTotalConstant.SALE_TOTAL_REPORT_KH_SUCCESS,
    data
  }
}

export const saleTotalReportKhError = (error) => {
  return {
    type: saleTotalConstant.SALE_TOTAL_REPORT_KH_ERROR,
    error
  }
}
export const saleTotalReportKhoXuatRequest = (formData) => {
  return {
    type: saleTotalConstant.SALE_TOTAL_REPORT_KHOXUAT_REQUESTING,
    payload: formData
  }
}

export const saleTotalReportKhoXuatSuccess = (data) => {
  return {
    type: saleTotalConstant.SALE_TOTAL_REPORT_KHOXUAT_SUCCESS,
    data
  }
}

export const saleTotalReportKhoXuatError = (error) => {
  return {
    type: saleTotalConstant.SALE_TOTAL_REPORT_KHOXUAT_ERROR,
    error
  }
}
export const saleTotalReportListRequest = (formData) => {
  return {
    type: saleTotalConstant.SALE_TOTAL_REPORT_LIST_REQUESTING,
    formData
  }
}

export const saleTotalReportListSuccess = (data) => {
  return {
    type: saleTotalConstant.SALE_TOTAL_REPORT_LIST_SUCCESS,
    data
  }
}

export const saleTotalReportListError = (error) => {
  return {
    type: saleTotalConstant.SALE_TOTAL_REPORT_LIST_ERROR,
    error
  }
}

export const reportExportXlsRequest = (formData, callback) => {
  return {
    type: saleTotalConstant.SALE_TOTAL_REPORT_EXPORT_XLS_REQUESTING,
    formData,
    callback
  }
}

export const reportExportXlsSuccess = (data) => {
  return {
    type: saleTotalConstant.SALE_TOTAL_REPORT_EXPORT_XLS_SUCCESS,
    data
  }
}

export const reportExportXlsError = (error) => {
  return {
    type: saleTotalConstant.SALE_TOTAL_REPORT_EXPORT_XLS_ERROR,
    error
  }
}
export const saleTotalReportNhomKhRequest = (formData, callback) => {
  return {
    type: saleTotalConstant.SALE_TOTAL_REPORT_NHOMKH_REQUESTING,
    payload: formData,
    callback
  }
}

export const saleTotalReportNhomKhSuccess = (data) => {
  return {
    type: saleTotalConstant.SALE_TOTAL_REPORT_NHOMKH_SUCCESS,
    data
  }
}

export const saleTotalReportNhomKhError = (error) => {
  return {
    type: saleTotalConstant.SALE_TOTAL_REPORT_NHOMKH_ERROR,
    error
  }
}

export const saleTotalReportKhByNhomRequest = (formData, callback) => {
  return {
    type: saleTotalConstant.SALE_TOTAL_REPORT_KH_BY_NHOM_REQUESTING,
    payload: formData,
    callback
  }
}

export const saleTotalReportKhByNhomSuccess = (data) => {
  return {
    type: saleTotalConstant.SALE_TOTAL_REPORT_KH_BY_NHOM_SUCCESS,
    data
  }
}

export const saleTotalReportKhByNhomError = (error) => {
  return {
    type: saleTotalConstant.SALE_TOTAL_REPORT_KH_BY_NHOM_ERROR,
    error
  }
}


// WEBPACK FOOTER //
// ./src/views/Reports/SaleTotalReport/actions.js